module.exports = __webpack_public_path__ + "img/sm-164906089200420220217072336.f3ac88f3.jpg";